module.exports = __webpack_public_path__ + "static/media/notifications-gray.8b0abc76.svg";